<template>
  <el-dialog
    class="PhoneGuideDialog"
    :visible.sync="show"
    :show-close="false"
    :close-on-press-escape="false"
    :close-on-click-modal="false"
    :destroy-on-close="true"
  >
    <div class="register-box">
      <img :src="`${imgPath}/oneold/layout/close.png`" class="close" alt="" srcset="" @click="handleClose" />
      <div>
        <img class="successImg" :src="`${CDN}/0cdn/static/front/qlmBidding1_ForJSP/img/receive-bg.png`" alt="" />
        <img
          class="btn"
          :src="`${CDN}/0cdn/static/front/qlmBidding1_ForJSP/img/receive-btn.png`"
          alt=""
          @click="handleBtn"
        />
      </div>
    </div>
  </el-dialog>
</template>
<script>
import {imgPath, ossPath,} from "@/utils/constants/constants";
import { buryPointUserBehaviorInsertRecord } from "@/services/gjxx";

export default {
  name: "footerBannerShow",
  components: {

  },
  data() {
    return {
      username: '',
      CDN: ossPath,
      imgPath,
      bannerShow: true,
      show: true
    };
  },
  computed: {},
  created() {

  },
  mounted() {

  },
  methods: {
    showDialog() { //TODO:埋点
      this.show = true
      const obj = {
        oid: "86",
        deed: "3",
        source: "gw",
        level: "0",
        uid: 0,
        ctxid: "",
        url: window.location.href,
        refer:document.referrer
      }
      buryPointUserBehaviorInsertRecord(obj)
    },
    handleBtn() { //todo:maidian
      const obj = {
        oid: "87",
        deed: "2",
        source: "gw",
        level: "0",
        uid: 0,
        ctxid: "",
        url: window.location.href,
        refer:document.referrer
      }
      buryPointUserBehaviorInsertRecord(obj)
      this.$alert('拨打<span style="color:#DF6250">400-688-2000</span>立即加入', "", {
        confirmButtonText: "确定",
        dangerouslyUseHTMLString: true,
        confirmButtonClass: "confirmButtonClass",
      })
    },
    handleClose() {
      this.$emit("close")
    },
    childeClose() {
      this.show = false
    },
  }
};
</script>

<style lang="scss">
.confirmButtonClass {
  background: #df6250;
  border-color: #df6250;
}
.PhoneGuideDialog {
  .el-dialog {
    background: none;
    box-shadow: none;
    width: fit-content !important;
  }

  .el-dialog__header {
    display: none;
  }
}
</style>
<style lang="scss" scoped>
.register-box {
  position: relative;

  .close {
    cursor: pointer;
    position: absolute;
    top: -20px;
    right: 0;
    width: 20px;
    height: 20px;
  }
  .successImg {
    width: 523px;
    height: 577px;
  }
  .btn {
    cursor: pointer;
    position: absolute;
    bottom: 47px;
    left: 57px;
    width: 399px;
    height: 63px;
  }
}
</style>
